import React from 'react';
import PropTypes from 'prop-types';

// FSSAI non-vegetarian mark (India). Regulated colours, so no fill override.
const FssaiNonVegetarianIcon = ({ className, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 200 200"
  >
    <rect x="25" y="25" width="150" height="150" fill="none" stroke="#944a28" strokeWidth="5" />
    <path d="m46.02 146.77h107.96l-53.981-93.539z" fill="#944a28" />
  </svg>
);

FssaiNonVegetarianIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

FssaiNonVegetarianIcon.defaultProps = {
  height: '100%',
  width: '100%',
};

export default FssaiNonVegetarianIcon;
